import React from 'react';

const MarmaladeTheme = {
  headerLogo: {
    src: '/themes/theme/marmalade/marmalade-logo.png',
    alt: 'Marmalade Agency Logo',
    size: 35,
  },
  darkLogo: {
    src: '/themes/theme/marmalade/marmalade-logo.png',
    alt: 'Marmalade Agency Logo',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #000',
    height: 70,
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'Marmalade Data',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img height="50" src="/themes/theme/marmalade/marmalade-logo.png" alt="Marmalade Agency Logo" />
      <br /><br />
      <h3>Marmalade Agency Influencers</h3>
    </div>
  ),
  shareSite: 'https://marmalader.dyzio.co',
};

export default MarmaladeTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/marmalade.js
 **/